{
  "markread": "標記為已讀",
  "newest": "最新",
  "unread": "未讀",
  "starred": "已加星標",
  "tags": "標籤",
  "alltags": "所有標籤",
  "timestamp": "{0,date} {0,time}",
  "hours": "{0,plural,one {1 小時},other {# 小時}}前",
  "minutes": "{0,plural,one {1 分鐘},other {# 分鐘}}前",
  "seconds": "{0,plural,one {1 秒},other {# 秒}}前",
  "days": "{0,plural,zero {今天},one {昨天},other {# 天前}}",
  "star": "加星標",
  "unstar": "取消星標",
  "mark": "標記為已讀",
  "unmark": "標記為未讀",
  "load_img": "顯示圖片",
  "open_window": "開啟",
  "searchbutton": "搜尋",
  "sources": "來源",
  "source_add": "新增來源",
  "source_opml": "或匯入一個 OPML 檔案",
  "source_export": "匯出來源",
  "source_edit": "編輯",
  "source_delete": "刪除",
  "source_warn": "真的刪除這個來源嗎？",
  "source_new": "新的未儲存來源",
  "source_title": "標題",
  "source_tags": "標籤",
  "source_comma": "以逗號分隔",
  "source_select": "請選擇來源",
  "source_type": "類型",
  "source_save": "儲存",
  "source_cancel": "取消",
  "source_saved": "已儲存",
  "source_last_post": "更新於",
  "no_entries": "找不到條目",
  "more": "更多",
  "login": "登入",
  "login_username": "使用者名稱",
  "login_password": "密碼",
  "no_title": "無標題",
  "error_saving_color": "無法儲存新顏色：",
  "error_share_native_abort": "無法分享項目—沒有分享目標，或者你已取消它。",
  "article_actions": "動作",
  "error_check_log_file": "發生錯誤，請檢查日誌檔案「{0}」。",
  "filter": "過濾器",
  "share_diaspora_label": "在 Diaspora 上分享",
  "error_add_source": "無法新增來源：",
  "share_copy_label": "複製連結至剪貼簿",
  "sources_refreshed": "來源已重新整理",
  "app_reload": "重新載入",
  "error_unknown_source": "未知的來源 ID：",
  "error_mark_item": "無法標記／取消標記項目：",
  "error_refreshing_source": "無法重新整理來源：",
  "error_sync": "無法從伺服器同步最後的變更：",
  "error_offline_storage_not_available": "離線儲存不可用。確保你的網頁瀏覽器{0}支援 IndexedDB API{1}，並且如果你正在使用的是基於 Google Chrome 的瀏覽器，請確保你沒有在無痕模式下執行 selfoss。",
  "error_invalid_subsection": "無效的小節：",
  "error_configuration": "無法載入配置。",
  "error_share_native": "無法分享項目。",
  "info_url_copied": "網址已複製至剪貼簿。",
  "close_entry": "關閉",
  "online_count": "伺服器上可用的項目",
  "searchremove": "隱藏搜尋",
  "offline_count": "本地可用的項目",
  "offline_navigation_unavailable": "目前在離線模式下無法切換標籤和來源。",
  "settingsbutton": "設定",
  "logoutbutton": "登出",
  "source_filter": "過濾器",
  "share_twitter_label": "在 Twitter 上分享",
  "share_facebook_label": "在 Facebook 上分享",
  "next": "下一個",
  "share_mastodon_label": "在 Mastodon 上分享",
  "share_pocket_label": "儲存至 Pocket",
  "refreshbutton": "重新整理來源",
  "share_wallabag_label": "儲存至 Wallabag",
  "share_wordpress_label": "在 WordPress 上分享",
  "share_mail_label": "使用電子郵件分享",
  "loginbutton": "登入",
  "source_autotitle_hint": "留空以自動獲取標題",
  "source_saving": "正在儲存來源變更…",
  "source_pwd_placeholder": "沒有變更",
  "source_go_to_settings": "在設定中開啟",
  "source_refresh": "重新整理這個來源",
  "error_edit_source": "無法儲存來源變更：",
  "search_label": "搜尋詞語",
  "login_invalid_credentials": "錯誤的使用者名稱／密碼",
  "login_offline": "離線儲存",
  "error": "發生錯誤",
  "streamerror": "沒有載入任何項目，重新載入嗎？",
  "reload_list": "重新載入列表",
  "app_update": "selfoss 已更新，請重新載入",
  "error_session_expired": "工作階段已過期",
  "error_delete_source": "無法刪除來源：",
  "error_load_tags": "無法載入標籤：",
  "error_unknown_tag": "未知的標籤：",
  "error_mark_items": "無法標記所有可見項目：",
  "error_star_item": "無法加星標／取消星標項目：",
  "error_logout": "無法登出：",
  "error_loading": "載入錯誤：",
  "error_loading_stats": "無法載入導航統計資料：",
  "error_offline_storage": "離線儲存錯誤：{0}。重新載入可能會有所幫助。暫時停用離線功能。",
  "share_native_label": "分享",
  "sources_loading": "正在載入來源…",
  "no_sources": "沒有已配置的來源。",
  "source_menu": "更多動作",
  "source_browse": "瀏覽",
  "source_deleting": "正在刪除來源…",
  "source_warn_cancel_dirty": "放棄未儲存的變更？",
  "source_params_loading": "正在載入參數…",
  "tag_change_color_button_title": "變更顏色",
  "entries_loading": "正在載入條目…",
  "login_in_progress": "正在嘗試登入…",
  "login_error_generic": "無法登入：{errorMessage}",
  "experimental": "實驗性",
  "error_unauthorized": "請{link_begin}登入{link_end}以繼續。",
  "error_check_system_logs": "發生錯誤，請檢查你的系統日誌。",
  "error_unwritable_logs": "無法寫入日誌。",
  "article_reading_time": "{0} 分鐘閱讀",
  "sources_leaving_unsaved_prompt": "未儲存來源變更，離開設定？"
}
